import React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { InfoTooltip } from 'src/app/shared/components/tooltips';
import { useTrackView } from 'src/app/shared/hooks/tracking';

import { BarChart } from './components/BarChart';
import { InsightBox } from './components/InsightBox';
import { useTopSignatureSources } from './hooks/useTopSignatureSources';

export function TopSignatureSources(): React.JSX.Element | null {
	const {
		data: { topChannel, showInsightBox, promoteLink, channelSignatureCounts, otherSignatureSource },
		actions: { handlePromoteClick, handleShareClick },
	} = useTopSignatureSources();

	useTrackView('petition_manage_signature_insights_section_view', { topChannel: topChannel?.channel });

	// Not technically possible because the component should not render without data
	if (channelSignatureCounts.length === 0) return null;

	return (
		<Box as="section" aria-labelledby="top-signature-sources" p={24}>
			<Flex mb={24} sx={{ alignItems: 'center', gap: 4 }}>
				<Heading as="h3" size="h4" id="top-signature-sources">
					<Translate value="corgi.petition.starter_dashboard.petition_insights.signature_sources.title" />
				</Heading>
				<InfoTooltip aria-describedby="top-signature-sources">
					<Translate value="corgi.petition.starter_dashboard.petition_insights.signature_sources.tip" />
				</InfoTooltip>
			</Flex>
			{topChannel && showInsightBox ? (
				<InsightBox
					topChannel={topChannel}
					promoteLink={promoteLink}
					handlePromoteClick={handlePromoteClick}
					handleShareClick={handleShareClick}
				/>
			) : null}
			<BarChart allChannels={channelSignatureCounts} otherSignatureSource={otherSignatureSource} />
		</Box>
	);
}
